import React, {ReactElement} from "react";
import {Listbox} from "@headlessui/react";
import {ReactComponent as ChevronDownIcon} from "components/Icons/chevron-down.svg";
import {FormattedMessage} from "react-intl";

interface FormSelectProps<T> {
    options: readonly T[]
    selected: T
    getLabel: (t: T) => string
    onChange: (t: T) => void
}

export function FormSelect<T>(props: FormSelectProps<T>): ReactElement {
    return (
        <Listbox
            value={props.selected}
            onChange={props.onChange}
        >
            <div className="relative">
                <Listbox.Button
                    className="w-full flex items-center gap-2
                           bg-white text-sm
                           rounded border border-gray-1 outline-0
                           focus:border-focus">
                    <span className="flex-auto truncate text-left px-2 py-3">
                        <FormattedMessage id={`size.${props.getLabel(props.selected)}`}
                                          defaultMessage={props.getLabel(props.selected)}
                        />
                    </span>
                    <span className="flex-none pr-3"><ChevronDownIcon className="h-1.5 w-auto" /></span>
                </Listbox.Button>
                <Listbox.Options className="absolute w-full z-popover
                                            py-1 mt-1 overflow-auto
                                            bg-white rounded-md drop-shadow-dropdown-menu">
                    {props.options.map(t => {
                        const label = props.getLabel(t);
                        return (
                            <Listbox.Option
                                key={label}
                                value={t}
                                className="py-2 pl-2"
                            >
                                <FormattedMessage id={`size.${label}`}
                                                  defaultMessage={label}
                                />
                            </Listbox.Option>
                        );
                    })}
                </Listbox.Options>
            </div>
        </Listbox>
    );
}